<template>
  <base-dblclick-input
    modelType="contact"
    :model-id="clientContact.id"
    field-name="middle_name"
    :field-value="clientContact.middle_name"
    inputType="text"
    @refetch="fetchNewClients"
  ></base-dblclick-input>
</template>

<script>
  export default {
      name: "company-contact-middle-name-cell"
  }
</script>

<script setup>
import { defineProps, defineEmits } from "vue";

  const props = defineProps({
      clientContact: Object
  })

  const emit = defineEmits(['refetch-clients'])

  function fetchNewClients () {
      emit('refetch-clients')
  }
</script>